/* Couleurs sémantiques d'un score /100 — extrait de ResultsDisplay.tsx.
 * `scoreColor` : couleur de texte ; `scoreBg` : couleur de tracé (SVG stroke). */

export function scoreColor(score: number): string {
  if (score >= 80) return 'text-emerald-500';
  if (score >= 60) return 'text-yellow-500';
  if (score >= 40) return 'text-orange-500';
  return 'text-red-500';
}

export function scoreBg(score: number): string {
  if (score >= 80) return 'stroke-emerald-500';
  if (score >= 60) return 'stroke-yellow-500';
  if (score >= 40) return 'stroke-orange-500';
  return 'stroke-red-500';
}
